import { getSonarObjectTypeLabelPlural } from '@sonar-software/sonar-ts-lib';
import React from 'react';
import { UnorderedListOutlined } from '@ant-design/icons';
export const SearchTypeLabel = ({ sonarObjectType }) => React.createElement(React.Fragment, null,
    React.createElement(UnorderedListOutlined, null),
    "\u00A0",
    getSonarObjectTypeLabelPlural(sonarObjectType));
